import { create } from "zustand";


const useMuteStore = create(
    (set) => ({
        isMuted: false,
        setMute: (mute) => set(() => ({ isMuted: mute, volume: mute ? 0 : 0.2 })),
        volume: 0.2,
        setVolume: (volume) => set(() => ({ volume: volume })),
    }),
);

export default useMuteStore;
